import React from 'react';

// Landing page for the "Continue" button of Firebase's hosted password-reset
// widget. Every reset flow in the product uses it as the continue URL:
//   - SimpleOffice login "Forgot password?" (my-app Login.jsx, client SDK)
//   - employee "Set Password" invitations (employeesF actionCodeSettings)
//   - admin portal "send password reset" (adminDashboardF actionCodeSettings)
// By the time this renders Firebase has already saved the new password, so the
// page only tells the person where to sign in. It deliberately reads nothing
// from the URL - an old or re-opened link must never show an error here.
// Same Deep Harbor identity as FinishSignUp.jsx.
const C = {
  bg: '#0f1620',
  card: '#16202e',
  border: '#2a3a4f',
  text: '#e8eef5',
  dim: '#96a5b4',
  accent: '#9ecbf7',
  button: '#2f66b8',
  ok: '#2ea183',
};

const OFFICE_APP_URL = 'https://simplicity-office.web.app';

const PasswordSaved = () => (
  <div
    style={{
      minHeight: '100vh',
      background: C.bg,
      backgroundImage:
        'linear-gradient(rgba(158,203,247,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(158,203,247,0.05) 1px, transparent 1px)',
      backgroundSize: '32px 32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
    }}
  >
    <div
      style={{
        background: C.card,
        border: '1px solid ' + C.border,
        borderRadius: 10,
        padding: '28px 24px',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
      }}
    >
      <div style={{ color: C.accent, fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 6 }}>
        Simplicity Dynamics
      </div>
      <h1 style={{ color: C.text, fontSize: 22, fontWeight: 700, margin: '0 0 10px' }}>
        Your password is saved <span style={{ color: C.ok }}>✓</span>
      </h1>
      <p style={{ color: C.dim, fontSize: 15, lineHeight: 1.5, margin: '0 0 18px' }}>
        Sign in with your email and the new password.
      </p>
      <a
        href={OFFICE_APP_URL}
        style={{
          display: 'block',
          textAlign: 'center',
          background: C.button,
          color: '#fff',
          padding: '11px 12px',
          borderRadius: 6,
          fontSize: 15,
          fontWeight: 600,
          textDecoration: 'none',
        }}
      >
        Sign in to SimpleOffice
      </a>
      <p style={{ color: C.dim, fontSize: 13.5, lineHeight: 1.5, margin: '16px 0 0' }}>
        Using SimpleWork on your phone? Open the app and sign in there with the new password.
      </p>
    </div>
  </div>
);

export default PasswordSaved;
